import { FC, SVGProps } from "react";

const NoSSR: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="756" height="459" viewBox="0 0 756 459" fill="none"  {...props}>
      <g clipPath="url(#clip0_540_1033)">
        <path
          opacity="0.4"
          d="M278.035 70.5598C280.94 49.4 297.857 33.1613 318.3 33.1613C330.788 33.1613 341.958 39.2294 349.425 48.771C353.764 46.1532 358.759 44.6546 364.084 44.6546C370.869 44.6546 377.13 47.0828 382.159 51.1714C387.339 43.1653 395.943 37.9205 405.684 37.9205C420.725 37.9205 433.05 50.4036 434.251 66.2816C434.286 66.2816 434.32 66.2816 434.354 66.2816C444.306 66.2816 452.781 73.0897 455.991 82.622C460.819 79.7545 466.363 78.1218 472.264 78.1218C490.918 78.1218 506.045 94.4207 506.045 114.531C506.045 134.641 490.922 150.939 472.264 150.939H278.936C258.338 150.939 241.641 132.943 241.641 110.743C241.641 88.5422 257.853 71.0871 278.035 70.569V70.5598Z"
          fill="url(#paint0_linear_540_1033)"
        />
        <path
          opacity="0.4"
          d="M471.014 191.017C473.555 191.017 476.035 191.295 478.43 191.818C478.644 169.936 495.161 152.264 515.519 152.264C522.347 152.264 528.737 154.257 534.229 157.726C539.645 154.844 545.739 153.216 552.193 153.216C564.681 153.216 575.851 159.285 583.318 168.826C587.656 166.208 592.651 164.71 597.977 164.71C604.761 164.71 611.022 167.138 616.052 171.227C621.231 163.221 629.835 157.976 639.577 157.976C654.618 157.976 666.942 170.459 668.144 186.337C668.178 186.337 668.213 186.337 668.247 186.337C678.198 186.337 686.674 193.145 689.884 202.677C694.711 199.81 700.256 198.177 706.156 198.177C724.811 198.177 739.938 214.476 739.938 234.586C739.938 254.696 724.815 270.995 706.156 270.995L526.87 270.819H518.922C517.798 270.93 516.665 270.995 515.515 270.995C514.365 270.995 513.232 270.93 512.108 270.819H474.422C473.297 270.93 472.164 270.995 471.014 270.995C450.523 270.995 433.916 253.095 433.916 231.011C433.916 208.926 450.528 191.027 471.014 191.027V191.017Z"
          fill="url(#paint1_linear_540_1033)"
        />
        <path
          opacity="0.4"
          d="M108.888 253.962C108.888 235.013 123.139 219.658 140.716 219.658C140.974 219.658 141.227 219.672 141.48 219.681C144.278 216.263 148.115 213.853 152.453 213.016C153.153 194.738 167.116 180.146 184.252 180.146C198.113 180.146 209.896 189.696 214.265 203.021C217.745 199.145 222.624 196.731 228.023 196.731C234.516 196.731 240.249 200.214 243.712 205.542C244.836 205.32 245.991 205.2 247.175 205.2C257.277 205.2 265.542 213.631 266.267 224.315C275.734 230.258 282.098 241.308 282.098 253.967C282.098 272.916 267.846 288.271 250.269 288.271H138.957V288.216C122.195 287.23 108.888 272.273 108.888 253.962V253.962Z"
          fill="url(#paint2_linear_540_1033)"
        />
        <path
          opacity="0.4"
          d="M247.746 368.387L230.95 363.35L-0.115322 401.48L-3.56125 409.634L247.746 368.387Z"
          fill="url(#paint3_linear_540_1033)"
        />
        <path
          opacity="0.4"
          d="M430.758 358.061L430.174 347.849L4.25371 413.471L0.807779 421.625L430.758 358.061Z"
          fill="url(#paint4_linear_540_1033)"
        />
        <path
          opacity="0.4"
          d="M251.879 402.948L340.082 380.322L-2.92184 428.211L-6.36777 436.365L241.931 404.946C245.274 404.456 248.596 403.79 251.883 402.948H251.879Z"
          fill="url(#paint5_linear_540_1033)"
        />
        <path
          opacity="0.4"
          d="M215.043 360.295L198.496 356.017L-5.18664 386.761L3.34443 392.501L215.043 360.295Z"
          fill="url(#paint6_linear_540_1033)"
        />
        <path
          d="M153.213 321.897L236.211 303.781L152.041 222.346C152.041 222.346 143.446 213.36 136.395 213.952L115.316 213.3L153.209 321.897H153.213Z"
          fill="url(#paint7_linear_540_1033)"
        />
        <path
          d="M115.32 213.3L151.852 318.049L230.941 298.97L230.949 298.776L219.946 288L160.452 302.078L120.036 213.54L115.32 213.3Z"
          fill="url(#paint8_linear_540_1033)"
        />
        <path
          d="M638.792 253.522C638.792 253.522 669.075 271.259 674.534 274.524C674.534 274.524 696.304 285.486 684.172 295.536C684.172 295.536 676.89 303.843 642.079 312.408C642.079 312.408 630.595 315.096 622.519 316.317C622.519 316.317 356.252 354.955 317.454 359.64C317.454 359.64 284.639 362.669 263.075 361.078L133.079 340.487C133.079 340.487 120.514 338.531 123.685 331.108C123.685 331.108 125.346 325.114 139.657 321.423C139.657 321.423 215.313 298.436 273.271 291.743L582.035 247.819C582.035 247.819 621.978 241.76 638.787 253.522H638.792Z"
          fill="url(#paint9_linear_540_1033)"
        />
        <path
          d="M514.699 316.372L519.467 354.589L469.756 361.628L431.096 359.418L428.65 337.541L464.869 323.309L514.699 316.372Z"
          fill="url(#paint10_linear_540_1033)"
        />
        <path
          d="M538.903 308.03L343.589 338.551L247.039 380.805C247.039 380.805 242.331 378.373 240.739 380.454C240.117 381.268 240.804 385.125 241.147 386.106C241.147 386.106 242.022 388.307 249.652 387.526L325.896 376.62C325.896 376.62 362.097 370.954 407.173 353.827L539.436 312.747L538.908 308.025L538.903 308.03Z"
          fill="url(#paint11_linear_540_1033)"
        />
        <path
          d="M671.389 272.665L626.712 279.802C626.712 279.802 621.06 279.589 621.906 274.219L623.056 262.134C623.056 262.134 623.528 256.764 628.54 256.357L640.41 254.526L671.389 272.67V272.665Z"
          fill="#002F87"
        />
        <g opacity="0.47">
          <path
            d="M595.964 299.006L609.232 297.129C611.061 296.87 612.352 295.057 612.112 293.082L608.554 263.883C608.314 261.913 606.632 260.521 604.799 260.78L591.531 262.658C589.703 262.917 588.407 264.73 588.647 266.705L592.204 295.903C592.445 297.873 594.127 299.265 595.959 299.006H595.964ZM604.945 261.969C606.164 261.797 607.288 262.722 607.447 264.041L611.005 293.239C611.163 294.552 610.305 295.764 609.082 295.935L595.813 297.813C594.595 297.984 593.47 297.059 593.312 295.741L589.754 266.543C589.595 265.229 590.454 264.017 591.677 263.846L604.945 261.969Z"
            fill="url(#paint12_linear_540_1033)"
          />
        </g>
        <path d="M216.176 329.329L168.594 329.602L118.068 351.909L139.254 351.942L216.176 329.329Z" fill="url(#paint13_linear_540_1033)" />
        <path
          d="M538.611 305.805L343.005 333.801L246.455 376.055C246.455 376.055 239.408 378.775 240.632 382.253C240.632 382.253 241.344 383.923 249.073 382.776L325.316 371.87C325.316 371.87 361.518 366.204 406.593 349.077L539.07 309.523L538.615 305.8L538.611 305.805Z"
          fill="#0071CE"
        />
        <g opacity="0.47">
          <path
            d="M568.063 280.005C568.419 282.914 570.891 284.958 573.59 284.579C576.29 284.195 578.186 281.531 577.83 278.622C577.474 275.713 575.002 273.668 572.303 274.048C569.604 274.431 567.707 277.096 568.059 280.005H568.063Z"
            fill="url(#paint14_linear_540_1033)"
          />
          <path
            d="M552.773 287.483C550.052 287.483 547.846 285.106 547.846 282.173C547.846 279.241 550.052 276.864 552.773 276.864C555.494 276.864 557.699 279.241 557.699 282.173C557.699 285.106 555.494 287.483 552.773 287.483Z"
            fill="url(#paint15_linear_540_1033)"
          />
          <path
            d="M527.716 285.709C528.072 288.618 530.544 290.662 533.243 290.283C535.942 289.899 537.839 287.235 537.487 284.326C537.131 281.417 534.659 279.372 531.96 279.751C529.261 280.135 527.364 282.799 527.72 285.709H527.716Z"
            fill="url(#paint16_linear_540_1033)"
          />
          <path
            d="M512.425 293.187C509.704 293.187 507.499 290.81 507.499 287.877C507.499 284.945 509.704 282.568 512.425 282.568C515.146 282.568 517.352 284.945 517.352 287.877C517.352 290.81 515.146 293.187 512.425 293.187Z"
            fill="url(#paint17_linear_540_1033)"
          />
          <path
            d="M487.368 291.432C487.724 294.341 490.196 296.386 492.896 296.006C495.595 295.622 497.492 292.958 497.14 290.049C496.783 287.14 494.312 285.096 491.612 285.475C488.917 285.859 487.016 288.523 487.373 291.432H487.368Z"
            fill="url(#paint18_linear_540_1033)"
          />
          <path
            d="M472.079 298.91C469.359 298.91 467.153 296.533 467.153 293.601C467.153 290.668 469.359 288.291 472.079 288.291C474.8 288.291 477.006 290.668 477.006 293.601C477.006 296.533 474.8 298.91 472.079 298.91Z"
            fill="url(#paint19_linear_540_1033)"
          />
          <path
            d="M451.906 301.753C449.185 301.753 446.979 299.376 446.979 296.443C446.979 293.511 449.185 291.134 451.906 291.134C454.626 291.134 456.832 293.511 456.832 296.443C456.832 299.376 454.626 301.753 451.906 301.753Z"
            fill="url(#paint20_linear_540_1033)"
          />
          <path
            d="M426.849 299.998C427.205 302.907 429.677 304.951 432.376 304.572C435.075 304.188 436.972 301.524 436.62 298.615C436.264 295.705 433.792 293.661 431.093 294.04C428.394 294.42 426.497 297.088 426.853 299.998H426.849Z"
            fill="url(#paint21_linear_540_1033)"
          />
          <path
            d="M406.676 302.859C407.032 305.768 409.504 307.813 412.204 307.433C414.903 307.054 416.8 304.385 416.443 301.476C416.087 298.567 413.615 296.523 410.916 296.902C408.217 297.286 406.32 299.95 406.672 302.859H406.676Z"
            fill="url(#paint22_linear_540_1033)"
          />
          <path
            d="M391.386 310.337C388.665 310.337 386.46 307.96 386.46 305.028C386.46 302.095 388.665 299.718 391.386 299.718C394.107 299.718 396.312 302.095 396.312 305.028C396.312 307.96 394.107 310.337 391.386 310.337Z"
            fill="url(#paint23_linear_540_1033)"
          />
          <path
            d="M366.329 308.563C366.685 311.472 369.157 313.517 371.856 313.137C374.555 312.754 376.452 310.09 376.096 307.18C375.74 304.271 373.268 302.227 370.568 302.606C367.869 302.99 365.973 305.654 366.324 308.563H366.329Z"
            fill="url(#paint24_linear_540_1033)"
          />
          <path
            d="M346.191 311.397C345.837 308.49 347.737 305.823 350.434 305.442C353.132 305.06 355.606 307.107 355.96 310.015C356.314 312.922 354.415 315.589 351.717 315.971C349.019 316.352 346.545 314.305 346.191 311.397Z"
            fill="url(#paint25_linear_540_1033)"
          />
          <path
            d="M330.867 318.903C328.146 318.903 325.94 316.526 325.94 313.594C325.94 310.661 328.146 308.284 330.867 308.284C333.587 308.284 335.793 310.661 335.793 313.594C335.793 316.526 333.587 318.903 330.867 318.903Z"
            fill="url(#paint26_linear_540_1033)"
          />
          <path
            d="M305.809 317.148C306.165 320.057 308.637 322.102 311.336 321.722C314.031 321.338 315.932 318.674 315.576 315.765C315.22 312.856 312.748 310.812 310.049 311.191C307.35 311.57 305.453 314.239 305.805 317.148H305.809Z"
            fill="url(#paint27_linear_540_1033)"
          />
        </g>
        <path
          opacity="0.4"
          d="M120.049 92.5294L126.345 88.7368L258.482 110.096L257.315 116.779L120.049 92.5294Z"
          fill="url(#paint28_linear_540_1033)"
        />
        <path
          opacity="0.4"
          d="M110.407 106.72L117.587 103.085L249.725 124.444L248.553 131.131L110.407 106.72Z"
          fill="url(#paint29_linear_540_1033)"
        />
        <path
          opacity="0.4"
          d="M72.1801 110.152L75.4114 106.623L207.605 129.485L210.33 134.559L72.1801 110.152Z"
          fill="url(#paint30_linear_540_1033)"
        />
        <path
          d="M42.389 97.9435L119.354 108.951C119.354 108.951 108.355 112.822 78.8736 108.387C49.3924 103.947 40.8698 102.004 41.432 97.2682L41.4663 97.1526L42.3975 97.9389L42.389 97.9435Z"
          fill="#BAC7D5"
        />
        <g opacity="0.57">
          <path
            d="M41.4575 97.1592C41.4704 97.1269 42.0926 95.855 42.835 94.3287C42.835 94.3287 44.7447 90.4158 56.8633 92.0809C70.2178 93.9217 124.983 101.451 124.983 101.451C126.571 101.669 127.919 103.112 127.974 104.652C128.035 106.197 126.786 107.677 125.207 107.95L122.22 108.463C120.641 108.736 118.049 108.777 116.461 108.56L44.8991 98.7179C43.3114 98.5005 41.878 98.0843 41.7193 97.7975C41.5605 97.5107 41.4446 97.1916 41.4575 97.1592Z"
            fill="#BAC7D5"
          />
        </g>
        <path
          d="M84.0658 111.795C85.3833 111.943 86.5762 110.93 86.7436 109.506C86.9153 108.058 85.9668 106.74 84.6237 106.555L73.2002 104.983C71.8656 104.802 70.634 105.82 70.4624 107.267C70.2907 108.715 71.2391 110.033 72.5823 110.218L84.0057 111.791C84.0057 111.791 84.0444 111.795 84.0658 111.8V111.795Z"
          fill="#D0DAE2"
        />
        <g opacity="0.57">
          <path
            d="M96.2966 111.981C96.8287 111.967 97.2836 111.537 97.3523 110.954C97.4295 110.311 97.0047 109.719 96.4082 109.636L77.0716 106.976C76.4708 106.893 75.9258 107.351 75.8485 107.994C75.7713 108.637 76.1961 109.229 76.7926 109.312L96.1292 111.971C96.185 111.981 96.2408 111.981 96.2923 111.981H96.2966Z"
            fill="#BAC7D5"
          />
        </g>
        <path d="M106.604 98.9333L114.525 96.9398L128.661 83.1016L133.832 83.8092L127.172 101.759L106.604 98.9333Z" fill="#BAC7D5" />
        <g opacity="0.57">
          <path
            d="M136.172 92.4148C136.936 92.498 137.627 91.9106 137.721 91.0874C137.82 90.2502 137.27 89.4871 136.494 89.3807L126.473 88.0071C125.701 87.9053 124.989 88.4927 124.89 89.3298C124.791 90.167 125.341 90.9301 126.117 91.0365L136.137 92.4101C136.137 92.4101 136.159 92.4101 136.172 92.4101V92.4148Z"
            fill="#BAC7D5"
          />
        </g>
      </g>
      <defs>
        <linearGradient id="paint0_linear_540_1033" x1="374.551" y1="4.57353" x2="373.03" y2="204.964" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC7D5" />
          <stop offset="1" stopColor="#BAC7D5" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint1_linear_540_1033" x1="582.648" y1="58.7904" x2="591.924" y2="383.593" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC7D5" />
          <stop offset="1" stopColor="#BAC7D5" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint2_linear_540_1033" x1="194.319" y1="169.272" x2="196.856" y2="326.381" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC7D5" />
          <stop offset="1" stopColor="#BAC7D5" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint3_linear_540_1033" x1="209.395" y1="368.831" x2="11.0455" y2="400.959" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC7D5" />
          <stop offset="1" stopColor="#BAC7D5" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint4_linear_540_1033" x1="351.901" y1="358.103" x2="4.24858" y2="409.227" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC7D5" />
          <stop offset="1" stopColor="#BAC7D5" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint5_linear_540_1033" x1="280.27" y1="386.039" x2="-3.72471" y2="426.205" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC7D5" />
          <stop offset="1" stopColor="#BAC7D5" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint6_linear_540_1033" x1="249.734" y1="348.103" x2="-12.0805" y2="386.171" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC7D5" />
          <stop offset="1" stopColor="#BAC7D5" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint7_linear_540_1033" x1="230.151" y1="253.997" x2="121.896" y2="267.185" gradientUnits="userSpaceOnUse">
          <stop stopColor="#009681" />
          <stop offset="1" stopColor="#008188" />
        </linearGradient>
        <linearGradient id="paint8_linear_540_1033" x1="225.335" y1="252.659" x2="478.606" y2="221.805" gradientUnits="userSpaceOnUse">
          <stop stopColor="#009681" />
          <stop offset="1" stopColor="#008188" />
        </linearGradient>
        <linearGradient id="paint9_linear_540_1033" x1="397.415" y1="244.655" x2="409.748" y2="331.807" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E7F5FD" />
          <stop offset="0.28" stopColor="#E3F2FC" />
          <stop offset="0.54" stopColor="#D8EBF9" />
          <stop offset="0.79" stopColor="#C5E0F4" />
          <stop offset="1" stopColor="#B0D3EF" />
        </linearGradient>
        <linearGradient id="paint10_linear_540_1033" x1="470.288" y1="309.255" x2="475.097" y2="349.728" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E7F5FD" />
          <stop offset="0.28" stopColor="#E3F2FC" />
          <stop offset="0.54" stopColor="#D8EBF9" />
          <stop offset="0.79" stopColor="#C5E0F4" />
          <stop offset="1" stopColor="#B0D3EF" />
        </linearGradient>
        <linearGradient id="paint11_linear_540_1033" x1="541.209" y1="326.976" x2="238.218" y2="363.887" gradientUnits="userSpaceOnUse">
          <stop stopColor="#009681" />
          <stop offset="1" stopColor="#008188" />
        </linearGradient>
        <linearGradient id="paint12_linear_540_1033" x1="597.973" y1="256.519" x2="606.906" y2="331.131" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint13_linear_540_1033" x1="216.487" y1="331.888" x2="117.104" y2="343.995" gradientUnits="userSpaceOnUse">
          <stop stopColor="#009681" />
          <stop offset="1" stopColor="#008188" />
        </linearGradient>
        <linearGradient id="paint14_linear_540_1033" x1="570.398" y1="265.756" x2="576.746" y2="294.867" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint15_linear_540_1033" x1="550.506" y1="270.096" x2="556.853" y2="299.207" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint16_linear_540_1033" x1="530.61" y1="274.424" x2="536.958" y2="303.535" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint17_linear_540_1033" x1="510.713" y1="278.765" x2="517.061" y2="307.876" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint18_linear_540_1033" x1="490.818" y1="283.113" x2="497.165" y2="312.224" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint19_linear_540_1033" x1="470.922" y1="287.453" x2="477.27" y2="316.564" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint20_linear_540_1033" x1="451.026" y1="291.778" x2="457.379" y2="320.888" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint21_linear_540_1033" x1="431.134" y1="296.121" x2="437.482" y2="325.232" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint22_linear_540_1033" x1="411.24" y1="300.465" x2="417.587" y2="329.576" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint23_linear_540_1033" x1="391.343" y1="304.805" x2="397.691" y2="333.916" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint24_linear_540_1033" x1="371.446" y1="309.13" x2="377.795" y2="338.245" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint25_linear_540_1033" x1="351.589" y1="313.46" x2="357.936" y2="342.571" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint26_linear_540_1033" x1="331.66" y1="317.814" x2="338.008" y2="346.924" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint27_linear_540_1033" x1="311.764" y1="322.161" x2="318.112" y2="351.272" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.6" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint28_linear_540_1033" x1="103.004" y1="82.4559" x2="196.256" y2="100.004" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC7D5" />
          <stop offset="1" stopColor="#BAC7D5" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint29_linear_540_1033" x1="100.061" y1="98.0944" x2="193.317" y2="115.642" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC7D5" />
          <stop offset="1" stopColor="#BAC7D5" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="paint30_linear_540_1033" x1="97.7048" y1="110.596" x2="190.961" y2="128.144" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC7D5" />
          <stop offset="1" stopColor="#BAC7D5" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_540_1033">
          <rect width="755.686" height="458.675" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoSSR;
